import { Component, OnInit, ViewChild } from '@angular/core';
import { LeftSideNavComponent } from '../../../shared/layout/app/left-menu/left-side-nav.component';
import { HeaderComponent } from '../../../shared/layout/app/header/header.component';
import { ProfileBllService } from '../../profile/profile-bll.service';
import { UserService } from '../../../core/services/user.service';
import { UserEventStatusRespModel } from '../../profile/profile.model';
import { APIErrorModel, BaseResponse } from '../../../shared/models/base-response.model';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DigitalCatalogueBllService } from '../digital-catalogue-bll.service';
import { LoaderService } from '../../../shared/components/loader/loader.service';
import { InterestSharedSuccessPopupComponent } from '../../../shared/components/interest-shared-success-popup/interest-shared-success-popup.component';

import { InterestSharePopupComponent } from "../../../shared/components/interest-share-popup/interest-share-popup.component";
import { CompanyDetailsModel, ParamsToGetProductsList, ProductListResponseModel, ContactMeDataModel } from '../digital-catalogue.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DeviceTypeService } from '../../../core/services/device-type.service';
import { VirtualEventBllService } from '../../virtual-event/virtual-event-bll.service';
import { HomeBllService } from '../../home/home-bll.service';
import { EventDetailsResponseModel } from '../../home/home.model';

@Component({
  selector: 'app-catalogue-company-details',
  imports: [LeftSideNavComponent, HeaderComponent, CommonModule, InterestSharePopupComponent, InterestSharedSuccessPopupComponent, RouterLink],
  templateUrl: './catalogue-company-details.component.html',
  styleUrls: ['./catalogue-company-details.component.scss']
})
export class CatalogueCompanyDetailsComponent implements OnInit {
  /**
      * User profile data
      */
  userProfile: UserEventStatusRespModel["user_profile"] | null = null;
  isUserStatusLoading = false;
  // variable to hold the source of user(android_web/ios_web/web)
  source: string = '';
  companyDetails: CompanyDetailsModel | null = null;
  activeTab: 'about' | 'products' | 'videos' = 'about';
  pavilionCode: string = '';

  /** Interest share popup component reference */
  @ViewChild('interestSharedPopup') interestSharedPopup!: InterestSharePopupComponent;
  @ViewChild('successModal') successModal!: InterestSharedSuccessPopupComponent;
  contactData: ContactMeDataModel = {
    brandName: '',
    productTitle: '',
    companyLogoUrl: '',
    userImageUrl: '',
    color: ''
  };
  // variable to hold do not show message again checkbox value
  doNotShowMessage: boolean = false;

  // variable to hold activity code
  activity_code: string = '';

  pavilionImgUrl: string = '';
  pavilionName: string = '';
  productList: ProductListResponseModel['list'] = [];
  readonly limit = 130;
  isExpanded = false;
  isLongText = false;

  truncatedContent!: SafeHtml;
  fullContent!: SafeHtml;
  isLoadingMore: boolean = false;
  areImagesAvailable: boolean = false;

  // variable to check whether the product is liked or not
  liked: boolean = false;

  // variable to show success message on shortlist
  successMsg: boolean = false;
  successText: string = '';

  // variable to check whether user has registered as virtual visitor
  hasRegisteredAsVirtualVisitor: boolean = false;
  eventDetails: EventDetailsResponseModel | null = null;

  constructor(
    private profileBll: ProfileBllService,
    private userService: UserService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private catalogueBllService: DigitalCatalogueBllService,
    private loader: LoaderService,
    private sanitizer: DomSanitizer,
    private deviceService: DeviceTypeService,
    private virtualBll: VirtualEventBllService,
    private homeBll: HomeBllService,
  ) { }

  ngOnInit(): void {

    const companyId = this.getCompanyId();
    const companyUserId = this.getCompanyUserId();
    this.getCompanyDetails(companyId);
    this.loadCompanyProducts({ company_id: parseInt(companyUserId) });
    const pavilionDetails = this.catalogueBllService.getSelectedPavilionDetails();

    if (pavilionDetails) {
      this.pavilionCode = pavilionDetails.pavilionCode || '';
      this.pavilionImgUrl = pavilionDetails.pavilionImgUrl || '';
      this.pavilionName = pavilionDetails.pavilionName || '';

    }

    // Get the source of user
    this.source = this.deviceService.getUserSource();

    this.fetchUserEventStatus();
    this.loadEventDetails();
  }

  /**
   * @description Fetches the user's event status and updates the user profile and service accordingly.
   */
  fetchUserEventStatus() {
    this.isUserStatusLoading = true;

    this.profileBll
      .submitGetUserEventStatus()
      .then((res: BaseResponse<UserEventStatusRespModel>) => {
        this.userProfile = res.data.user_profile;
        if (this.userProfile) {
          const previewLogo =
            this.userProfile.image_url ??
            "/assets/images/Default-profile-photo.png";
          const userName = `${this.userProfile.first_name} ${this.userProfile.last_name}`;
          this.userService.setUser({
            name: userName,
            profileImg: previewLogo,
            mobile: this.userProfile.mobile,
            state: this.userProfile.state,
            city: this.userProfile.city,
            hasUnassignedTickets: res.data.event_my_tickets.unassigned_tickets_bought_by_me > 0,
            hasAssignedTickets: res.data.event_my_tickets.assigned_tickets_bought_by_me > 0 || res.data.event_my_tickets.tickets_assigned_for_me > 0,
          });
        }
        this.doNotShowMessage = res.data.user_profile?.do_not_show_message || false;

        /**
         * @description Check if the user is an event attendee and register as a virtual visitor if true.
         */
        const attendee = res?.data?.event_my_tickets?.event_attendee_details;
        if (!attendee) {
          this.registerVirtualVisitor();
        }

      })
      .catch((err: APIErrorModel) => {
        console.error("Error fetching user event status:", err);
      })
      .finally(() => {
        this.isUserStatusLoading = false;

      });
  }

  /**
* @description Retrieves the company ID from query parameters.
* @returns {string} The company ID.
*/
  getCompanyId(): string {
    return decodeURIComponent(this.activatedRoute.snapshot.queryParamMap.get('id') || "");
  }
  getCompanyUserId() {
    return decodeURIComponent(this.activatedRoute.snapshot.queryParams["userId"]);
  }

  goBack() {
    window.history.back();
  }

  getCompanyDetails(companyId: string) {
    this.loader.show();
    this.catalogueBllService.fetchCompanyDetails(companyId).then((response) => {
      this.handleCompanyDetailsResponse(response);
    }
    ).catch((error: APIErrorModel) => {

      console.error("Error fetching company details:", error);
    }).finally(() => {
      this.loader.hide();
    });
  }

  handleCompanyDetailsResponse(response: BaseResponse<CompanyDetailsModel>): void {
    // Handle the response data as needed
    this.companyDetails = response.data;
    this.areImagesAvailable = this.companyDetails.media?.brand_media?.some(
      item => item.media_type === 'image'
    ) ?? false;
    const plainText = this.stripHtml(this.companyDetails.about);

    if (plainText.length > this.limit) {
      this.isLongText = true;

      // Add "..." inline (before Read more)
      const truncatedText = plainText.substring(0, this.limit) + '...';
      this.truncatedContent = this.sanitizer.bypassSecurityTrustHtml(truncatedText);
      this.fullContent = this.sanitizer.bypassSecurityTrustHtml(this.companyDetails.about);
    } else {
      this.truncatedContent = this.sanitizer.bypassSecurityTrustHtml(this.companyDetails.about);
    }

    this.liked = this.companyDetails?.liked || false;
  }

  setActiveTab(tab: 'about' | 'products' | 'videos') {
    this.activeTab = tab;
  }

  loadCompanyProducts(params: ParamsToGetProductsList): void {
    this.isLoadingMore = true;

    this.catalogueBllService.fetchProductList(params)
      .then((res) => {
        this.productList = res.data.list;

      })
      .catch((error) => {
        console.error("Error fetching company products:", error);
      }).finally(() => {
        this.isLoadingMore = false;
      });
  }

  get youtubeVideos() {
    return this.companyDetails?.media?.brand_media?.filter(
      item => item.media_type === "youtubevideo"
    ) ?? [];
  }

  goToProductDetails(productId: string | number): void {
    this.router.navigate(
      ['catalogue/product-details', productId]
    );
  }

  toggleReadMore(event: Event): void {
    event.preventDefault();
    this.isExpanded = !this.isExpanded;
  }

  private stripHtml(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  openMedia(url: string): void {
    window.open(url, '_blank');
  }

  /**
   * @description Opens the interest share popup or directly submits user activity based on the doNotShowMessage flag.
   */
  openModel(): void {
    if (this.doNotShowMessage) {
      this.activity_code = 'interested_in_company';
      this.callsubmitUserActivity();
    } else {
      this.openInterestSharePopup();
    }
  }

  /**
   * @description Opens the interest share popup.
   */
  openInterestSharePopup(): void {
    if (!this.companyDetails) return;

    const contactData: ContactMeDataModel = {
      brandName: this.companyDetails.brandname,
      productTitle: this.companyDetails.brandname,
      companyLogoUrl: this.companyDetails.image_bigthumb_url,
      userImageUrl: this.userProfile?.image_url ?? "/assets/images/Default-profile-photo.png",
      color: this.companyDetails.image_max_color || '#008940'
    };
    this.loader.hide();
    this.interestSharedPopup.show(contactData);
  }

  /**
   * 
   * @param isChecked Indicates whether the "Do Not Show" option is checked
   */
  onDoNotShowChange(isChecked: boolean) {
    this.doNotShowMessage = isChecked;
  }

  /**
   * @description Handles the confirmation action from the interest share popup.
   */
  onConfirmPopup() {
    this.activity_code = 'interested_in_company';
    this.callsubmitUserActivity();
  }

  /**
   * @description Handles the cancellation action from the interest share popup.
   */
  onCancelPopup() {
    this.doNotShowMessage = false;
    this.interestSharedPopup.resetDoNotShowCheckbox();
  }

  /**
   * @description Submits user activity indicating interest in the company.
   * @returns void
   */
  callsubmitUserActivity(): void {
    this.loader.show();
    if (!this.companyDetails) return;

    const activityRequest = {
      activity_code: this.activity_code,
      activity_for_item_id: this.companyDetails.user_id,
      activity_for_user_type: "exhibitor",
      activity_by_user_type: "visitor",
      activity_for_userid: this.companyDetails.user_id,
      for: 'company',
      source: this.source,
      do_not_show_message: this.doNotShowMessage
    };

    this.catalogueBllService.submitUserActivity(activityRequest)
      .then((res) => {
        this.loader.hide(); // Hide loader
        
        if (this.activity_code === 'like_profile') {
          this.liked = !this.liked;
          this.successText = this.catalogueBllService.getShortListMessage(this.liked);
          this.successMsg = true;
          setTimeout(() => {
            this.successMsg = false;
          }, 3000);
        }

        if (this.activity_code === 'interested_in_company') {
          this.interestSharedPopup.hide(); // Hide interest share popup
          this.successModal.show(this.companyDetails?.image_max_color || '#008940', 'exhibitor'); // Show success modal

          setTimeout(() => {
            this.successModal.hide(); // Hide after 3 seconds
          }, 5000);
        }

      }).catch((err) => {
        this.loader.hide();
        console.log(err)
      })
  }

  handleImageError(event: Event) {
    const img = event.target as HTMLImageElement;
    img.src = '/assets/images/default_company_image.png'; // fallback image
  }

  /**
   * @description Shortlists the company by submitting a 'like_profile' activity.
   */
  shortlistCompany(): void {
    this.activity_code = 'like_profile';
    this.callsubmitUserActivity();
  }

  get successGradientBackground(): string {

    const color = this.companyDetails?.image_max_color;

    // If productDetails OR the color is missing → return default gradient
    if (!color) {
      return this.catalogueBllService.getLinearGradient();
    }

    // Otherwise return gradient with actual color
    return this.catalogueBllService.getLinearGradient(color);
  }

  goToTicketPage(){
    this.router.navigate(["reg/select-ticket"]);
  }

  /**
   * @description Registers the user as a virtual visitor.
   */
  registerVirtualVisitor() {
    this.virtualBll.submitRegisterVirtualVisitor().then(() => {
      // Registration successful
      this.hasRegisteredAsVirtualVisitor = true;
    }).catch(() => {
      // Registration failed or already registered
      // We can choose to ignore errors here
      this.hasRegisteredAsVirtualVisitor = false;
    });
  }

  loadEventDetails() {
    this.homeBll.fetchEventDetails()
      .then((response) => {
        this.eventDetails = response.data;      
      
         this.userService.setLeftMenu({
          allow_to_register: this.eventDetails.allow_to_register,
          show_digital_catalog: this.eventDetails.show_digital_catalog,
          event_status: this.eventDetails.event_status
        });
        
      })
      .catch((error) => {
        console.error('Error fetching event details:', error);
      });
  }

}
